import DistinctSizesUploader from '../DistinctSizesUploader/DistinctSizesUploader'
import _ from 'lodash'

const DistinctSizesUploaderField = props => {
  const {
    input,
    readOnly,
    disabled,
    activePrimaryImageURL
  } = props

  const {
    onChange,
    value
  } = input

  const activePrimaryImage = value[activePrimaryImageURL]

  const updateFirstOrderImages = images => {
    const updatedFirstOrderImages = {
      ..._.cloneDeep(value),
      [activePrimaryImageURL]: images
    }

    onChange(updatedFirstOrderImages)
  }

  return (
    <DistinctSizesUploader
      readOnly={readOnly}
      disabled={disabled}
      activePrimaryImage={activePrimaryImage}
      updateFirstOrderImages={updateFirstOrderImages}
    />
  )
}

export default DistinctSizesUploaderField
